import styled from '@emotion/styled';
import { FormHelperText, InputLabel } from '@mui/material';

export const StyledInputLabel = styled(InputLabel)`
  font-size: 1rem;
  color: #333;
  margin-bottom: 8px;
  text-align: left;

  & .required {
    color: red;
  }
`;

export const StyledFormHelperText = styled(FormHelperText)`
  color: red;
  margin-left: 0px;
  font-size: 14px;
`;
